import { fetchSlider } from "./sliderSlice";
import { fetchStoreConfig } from "./storeConfigSlice";
import { createAsyncThunk } from '@reduxjs/toolkit';

export const initializeApp = createAsyncThunk('app/initialize', async (_, { dispatch }) => {
    await dispatch(fetchSlider());
    await dispatch(fetchStoreConfig());
});
